module.exports = __webpack_public_path__ + "static/102_home-55ec10d6aa124a429633bca9d2358f5b.png";